import { useState, useEffect } from 'react';
import { GetStepCount2, BulkActionsDownload } from '../../../actions/BulkActions';

const BulkDownloadDlg = (props) => {
    const [docCount, setDocCount] = useState(0);
    const [display, setDisplay] = useState('init');

    useEffect(() => {
        let search = props.getSearch();

        if(search.fullStep) {
          // need to query
          GetStepCount2(search, stepCountCallback);
        } else {
          setDocCount(search.docs.length);
        }
        setDisplay('init');
    }, []);

    const bulkDownloadClick = () => {
      let docs = props.docs();
      let search = props.getSearch();
      setDisplay('download');
      BulkActionsDownload(search, docs.docIds, finalCallback);
    }

    const finalCallback = (results) => {
      props.close('done');

    }

    const stepCountCallback = (count) => {
        setDocCount(count);

    }

    return (
        <div className='td-dialogue-container'>
            <div
              className='td-dialogue card'
              style={{ height: '600px', width: '600px' }}
            >
              <div className='card-header'>
                Bulk Download
                <button onClick={() => props.close()} className='btn-close' />
              </div>
              <div className='card-body'>
                {display === 'init' &&
                <>
                <div className='mt-2 ms-3'>
                  <label className='form-check-label'>
                    {docCount === 1 && (
                      <>1 document will be downloaded</>
                    )}
                    {docCount > 1 && (
                      <>{docCount} documents will be downloaded</>
                    )}
                  </label>
                </div>
                {docCount > 0 &&
                  <>

                    <button
                    onClick={bulkDownloadClick}
                    className='btn btn-primary mt-3 w-100'

                    >
                     Download
                    </button>
                  </>
                }
                </> }
                {display === 'download' &&
                    <div style={{width: '550px', textAlign: 'center'}}>
                        <div style={{fontSize: '16pt'}} className='mt-4'>Processing</div>
                        <div className='mt-4' style={{color: '#56b21e'}}>
                        <i className='fa-solid fa-spinner fa-spin fa-6x'></i>
                        </div>
                        <div style={{fontSize: '12pt'}} className='mt-4'>This may take a few minutes</div>
                        <button className='btn btn-secondary btn-lg mt-4' onClick={() => props.close('done')}>Close</button>
                    </div>
                }
                {display === 'done' &&
                  <div>
                    <div style={{fontSize: '12pt'}} className='mt-4'>{`${updateResults.length} document${updateResults.length > 1 ? 's' : ''} updated.`}</div>
                    <div style={{height: '300px', overflow: 'auto'}}>
                        <ul>
                            {updateResults.map((doc) => (
                                <li key={doc.documentId} >Document {doc.documentId}: {doc.message}</li>
                            ))}
                        </ul>
                    </div>
                    <button className='btn btn-secondary mt-1' onClick={() => props.close('done')}>Close</button>

                  </div>
                }
              </div>

            </div>
          </div>

    )
}

export default BulkDownloadDlg;